import { Card, Stack } from '@mui/material';
import {
    CreateButton,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
} from 'react-admin';
import { useSupplyDrawer } from '../drawer/SupplyDrawer';
import { SupplyListContent } from './SupplyListContent';
import { SupplyListFilter } from './SupplyListFilter';

export const SupplyListLayout = () => {
    const { openDrawer } = useSupplyDrawer();

    return (
        <Stack direction="row">
            <SupplyListFilter sx={{ mt: 2 }} />
            <Stack sx={{ width: '100%' }}>
                <Title title={'supply'} />
                <ListToolbar
                    actions={
                        <SupplyListActions
                            openCreateDrawer={() => openDrawer('create', null)}
                        />
                    }
                />
                <Card>
                    <SupplyListContent
                        openEditDrawer={id => openDrawer('show', id)}
                    />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const SupplyListActions = ({
    openCreateDrawer,
}: {
    openCreateDrawer?: () => void;
}) => (
    <TopToolbar>
        <SortButton
            fields={[
                'name',
                'createdAt',
                'updatedAt',
                'enabled',
                'price',
                'type',
            ]}
        />
        <CreateButton
            resource="supply"
            variant="contained"
            label="New supply"
            onClick={openCreateDrawer ?? undefined}
            sx={{ marginLeft: 2 }}
        />
    </TopToolbar>
);
